import { CSSProperties } from "react";

const Loader = ({
  className,
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) => {
  return (
    <div
      style={{
        zIndex: 100,
        ...(style ? style : {}),
      }}
      className={
        className ??
        `d-flex justify-content-center align-items-center w-100 loader-height`
      }
    >
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
